import { createActorContext } from '@xstate/react';
import React from 'react';
import { useSession } from '@acp/feature/auth';
import { propertyRequestCreatorMachine } from './machine';

const PropertyRequestCreatorContext = createActorContext(propertyRequestCreatorMachine);

function PropertyRequestCreatorProvider({
    children,
}: {
    children: React.ReactNode;
}) {
    const { complianceAgencyId } = useSession();

    return (
        <PropertyRequestCreatorContext.Provider
            logic={propertyRequestCreatorMachine.provide({
                actions: {
                    onPropertyRequestCreated: (_) => {},
                    navigateToLegacyJobOrderPage: (_, params) => {
                        window.location.href = `${params.url}&__acp_agency_id=${complianceAgencyId}`;
                    },
                },
            })}
            options={{
                input: {
                    supportedPayloadVersions: [
                        'ENROLMENT_V1_PAYLOAD_V1',
                        'URGENT_SERVICE_V1_PAYLOAD_V1',
                        'LEASE_RENEWAL_V1_PAYLOAD_V1',
                        'PRICING_CHANGE_V1_PAYLOAD_V1',
                        'IN_PERSON_MINIMUM_STANDARDS_V1_PAYLOAD_V1',
                    ],
                },
            }}
        >
            {children}
        </PropertyRequestCreatorContext.Provider>
    );
}

export { PropertyRequestCreatorContext };
// eslint-disable-next-line import/no-default-export
export default PropertyRequestCreatorProvider;
